export const endpoints = {
  maintenance: '/commands/central/:centralId/maintenanceMode',
  default: '/commands/central/:centralId/defaultMode',
}
